export default "__VITE_ASSET__CVGD3gip__"